var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticStyle:{"border-radius":"8px"}},[_c('v-row',{staticStyle:{"background":"var(--card-round-header-v2)"},attrs:{"no-gutters":"","justify":"center"}},[_c('h4',{staticClass:"white--text"},[_vm._v(_vm._s(_vm.title))])]),_c('v-row',{attrs:{"no-gutters":"","justify":"center"}},[_c('h4',[_vm._v(_vm._s(_vm.value))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }